<div class="container">
    <h1 class="page-title">
    <span class="icon"><i class="fas fa-truck-moving"></i></span>{{ 'RFQNew.NewHeader' | translate }}</h1>

  <p-card>
    <form [formGroup]="createForm">

      <div class="p-fluid formgrid grid">

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.Forwarder' | translate }}</label>
          <p-dropdown formControlName="forwarder"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [options]="bookingForwarderOptions"
                  [filter]="true"
                  (onChange)="getExpressInfo()"
                  [class]="showValidationMessage(createForm.controls.forwarder , submitted) ? ['ng-invalid', 'ng-dirty'] : []"
                 >
          </p-dropdown>
          <div *ngIf="createForm?.controls?.forwarder?.errors?.required" >
            <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.Status' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="status"  optionLabel="label" optionValue="value"  [options]="rfqStatusOptions"
            [disabled]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  [filter]="true" styleClass="p-text-left" >
            </p-dropdown>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.OriginCountry' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="fromCountry"  optionLabel="label" optionValue="value"  [options]="countryOptions" [showClear]="true"
              (onChange)="getFromCityOptions()" [filter]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}" styleClass="p-text-left"
              [class]="showValidationMessage(createForm.controls.fromCountry , submitted) ? ['ng-invalid', 'ng-dirty'] : []"  >
            </p-dropdown>

            <div *ngIf="createForm?.controls?.fromCountry?.errors?.required" >
              <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
            </div>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.OriginCity' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="fromCity"  optionLabel="label" optionValue="value"  [options]="fromCityOptions" [showClear]="true"
            (onChange)="getFromAreaOptions()"  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  [filter]="true" styleClass="p-text-left"
            [class]="showValidationMessage(createForm.controls.fromCity , submitted) ? ['ng-invalid', 'ng-dirty'] : []"
            [disabled]="disableDropdown1" >
            </p-dropdown>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.OriginArea' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="fromArea"  optionLabel="label" optionValue="value"  [options]="fromAreaOptions" [showClear]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  [filter]="true" styleClass="p-text-left"
              [disabled]="disableDropdown1"  >
            </p-dropdown>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.OriginCourierCity' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="expressFromArea"  optionLabel="label" optionValue="value"  [options]="expressFromAreaOptions" [showClear]="true"
             placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  [filter]="true" styleClass="p-text-left"
            [class]="showValidationMessage(createForm.controls.expressFromArea , submitted) ? ['ng-invalid', 'ng-dirty'] : []"
            [disabled]="disableDropdown1"  >
            </p-dropdown>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.DestinationCountry' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="toCountry"  optionLabel="label" optionValue="value"  [options]="countryOptions" [showClear]="true"
              (onChange)="getToCityOptions()" [filter]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}" styleClass="p-text-left"
              [class]="showValidationMessage(createForm.controls.toCountry , submitted) ? ['ng-invalid', 'ng-dirty'] : []" >
            </p-dropdown>

            <div *ngIf="createForm?.controls?.toCountry?.errors?.required" >
              <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
            </div>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.DestinationCity' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="toCity"  optionLabel="label" optionValue="value"  [options]="toCityOptions" [showClear]="true"
            (onChange)="getToAreaOptions()"  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  [filter]="true" styleClass="p-text-left"
            [class]="showValidationMessage(createForm.controls.toCity , submitted) ? ['ng-invalid', 'ng-dirty'] : []"
            [disabled]="disableDropdown2"  >

            </p-dropdown>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.DestinationArea' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="toArea"  optionLabel="label" optionValue="value"  [options]="toAreaOptions" [showClear]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  [filter]="true" styleClass="p-text-left"
              [disabled]="disableDropdown2"   >
            </p-dropdown>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.DestinationCourierCity' | translate }}</label>
          <div class="item">
            <p-dropdown formControlName="expressToArea"  optionLabel="label" optionValue="value"  [options]="expressToAreaOptions" [showClear]="true"
             placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  [filter]="true" styleClass="p-text-left"
            [class]="showValidationMessage(createForm.controls.expressToArea , submitted) ? ['ng-invalid', 'ng-dirty'] : []"
            [disabled]="disableDropdown2"  >
            </p-dropdown>
          </div>
        </div>


        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.AccountingCurrency' | translate }} </label>
            <p-dropdown formControlName="currency"  optionLabel="label" optionValue="value"  [options]="currencyOptions"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  [filter]="true" styleClass="p-text-left"
              [class]="showValidationMessage(createForm.controls.currency , submitted) ? ['ng-invalid', 'ng-dirty'] : []"  >
            </p-dropdown>
            <div *ngIf="createForm?.controls?.currency?.errors?.required" >
              <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
            </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.DocumentType' | translate }} </label>
          <div class="item">
            <p-dropdown formControlName="rfqCategory"  optionLabel="label" optionValue="value"  [options]="rfqCategoryTypeOptions" [showClear]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  [filter]="true" styleClass="p-text-left"
              (onChange)="addDetailStyle()"
              [class]="showValidationMessage(createForm.controls.rfqCategory , submitted) ? ['ng-invalid', 'ng-dirty'] : []"   >
            </p-dropdown>

            <div *ngIf="createForm?.controls?.rfqCategory?.errors?.required" >
              <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
            </div>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.PickUpAddress' | translate }} </label>
          <div class="item">
            <p-dropdown formControlName="awbAddress"  optionLabel="label" optionValue="value"  [options]="pickupLocationOptions" [showClear]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  [filter]="true" styleClass="p-text-left">
            </p-dropdown>

          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.CourierDeliveryCondition' | translate }} </label>
          <div class="item">
            <p-dropdown formControlName="expressTerm"  optionLabel="label" optionValue="value"  [options]="expressTermOptions" [showClear]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  [filter]="true" styleClass="p-text-left">
            </p-dropdown>


          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.Customer' | translate }}</label>
          <div class="item">
            <laas-customer-dropdown formControlName="consigneekey" [isSingle]="true" [divClass]="'p-fluid'"
                                    (onOptionDataChange)="changeConsignee($event)" (onDataLoaded)="onCustomerListLoaded($event)"></laas-customer-dropdown>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.ShippingType' | translate }}</label>
          <div class="item">
            <p-dropdown  #dd formControlName="shippingType"  optionLabel="label" optionValue="value"  [options]="shippingTypeOptions"
                          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"   styleClass="p-text-left"  >
            </p-dropdown>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.EffectiveDate' | translate }}</label>
          <div class="formgrid grid">
            <div class="col">
                <p-calendar formControlName="effectStartDate"   dateFormat="yy/mm/dd"  appendTo="body">
                </p-calendar>

                <div *ngIf="createForm?.controls?.effectStartDate?.errors?.required" >
                  <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
                </div>
            </div>
            <div class="col">
                <p-calendar formControlName="effectEndDate" dateFormat="yy/mm/dd"  appendTo="body">
                </p-calendar>

                <div *ngIf="createForm?.controls?.effectEndDate?.errors?.required" >
                  <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
                </div>
            </div>


          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.Effective' | translate }} </label>
          <div class="item">
            <p-dropdown formControlName="isActivated"  optionLabel="label" optionValue="value"  [options]="yesNoOption"
              [filter]="true" styleClass="p-text-left">
            </p-dropdown>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.Remarks' | translate }} </label>
          <div class="item">
            <textarea pInputTextarea  formControlName="remark"
            [rows]="3"
            ></textarea>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.OutsourcingCompany' | translate }} </label>
          <div class="item">
            <input pInputText type="text"  formControlName="outsourcingCompany" >
          </div>
        </div>
                <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.Facility' | translate }}</label>
          <div class="item">
            <laas-facility-dropdown 
              formControlName="facilityList"
              [isMultiple]="true" 
              [showFilter]="true"
              [showToggleAll]="true">
            </laas-facility-dropdown>

            <div *ngIf="createForm?.controls?.facilityList?.errors?.required" >
              <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
            </div>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.IsConsolidation' | translate }} </label>
          <div class="item">
            <p-dropdown formControlName="isConsolidation"  optionLabel="label" optionValue="value"  [options]="isConsolidationOptions"
              [filter]="true" styleClass="p-text-left">
            </p-dropdown>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.Creator' | translate }}</label>
          <div class="item">
            {{ createForm?.value.createUser }}
          </div>
        </div>


        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.CreationTime' | translate }}</label>
          <div class="item">
            {{ createForm?.value.createDt  | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone  }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.UpdateBy' | translate }}</label>
          <div class="item">
            {{ createForm?.value.updateUser }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQNew.EditTime' | translate }}</label>
          <div class="item">
            {{ createForm?.value.updateDt  | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone  }}
          </div>
        </div>
      </div>


      <div class="grid">
        <div class="col">
            <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}" (click)="createClick()"></button>
        </div>
      </div>

    </form>


    <p-accordion>
      <p-accordionTab header="{{ 'RFQNew.PrintDetails' | translate }}" [selected]="true">

        <form [formGroup]="createDetailForm">

          <div formArrayName="details">

            <p-table class="datatable" [value]="details.controls" [scrollable]="true"   [resizableColumns]="true"
               [columns]="detailColumns"   [paginator]="false" >

              <ng-template pTemplate="caption">
                <p-toolbar>
                  <div class="p-toolbar-group-left">
                    <button pButton pRipple label="{{ 'RFQNew.New' | translate }}" (click)="addDetail()"></button>
                  </div>
                </p-toolbar>
              </ng-template>

              <ng-template pTemplate="colgroup" let-columns>
                <colgroup>
                  <col style="width: 5vw;">
                  <col *ngFor="let col of columns" style="width: 12vw;">
                </colgroup>
              </ng-template>

              <ng-template pTemplate="header"  let-columns >
                <tr>
                  <th></th>
                  <th *ngFor="let col of columns"  pResizableColumn pReorderableColumn>
                    {{ col.header | translate }}
                  </th>
                </tr>

              </ng-template>

              <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">

                <tr [formGroupName]="rowIndex" >

                  <td><span class="icon" (click)="deleteBtnClick($event, details.controls , rowIndex)">
                    <i class="fas fa-trash-alt"></i></span>
                  </td>

                  <td>
                    <p-dropdown formControlName="feeType" [options]="feeTypeOptions" placeholder="{{ 'Common.Message.ChooseOption' | translate }}" appendTo="body"
                    [class]="showValidationMessage(rowData.controls.feeType , submitted) ? ['ng-invalid', 'ng-dirty'] : []" ></p-dropdown>
                  </td>

                  <td>
                    <p-dropdown formControlName="incoTerm" [options]="shipTermOptions" placeholder="{{ 'Common.Message.ChooseOption' | translate }}" appendTo="body"
                    [class]="showValidationMessage(rowData.controls.incoTerm , submitted) ? ['ng-invalid', 'ng-dirty'] : []" ></p-dropdown>
                  </td>

                  <td>
                    <input pInputText type="text"  formControlName="shippingSectionDesc"
                    [class]="showValidationMessage(rowData.controls.shippingSectionDesc , submitted) ? ['ng-invalid', 'ng-dirty'] : []"  />
                  </td>

                  <td>
                    <p-dropdown formControlName="currency"  optionLabel="label" optionValue="value"  [options]="currencyOptions" appendTo="body"
                      placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                      [class]="showValidationMessage(rowData.controls.currency , submitted) ? ['ng-invalid', 'ng-dirty'] : []" >
                    </p-dropdown>
                  </td>

                  <td>
                    <p-inputNumber   formControlName="unitPrice"  [minFractionDigits]="2"
                    [class]="showValidationMessage(rowData.controls.unitPrice , submitted) ? ['ng-invalid', 'ng-dirty'] : []" ></p-inputNumber>
                  </td>

                  <td>
                    <p-dropdown formControlName="calculationUnit"  [options]="calculationUnitOptions"   placeholder="{{ 'Common.Message.ChooseOption' | translate }}"   appendTo="body"
                    [class]="showValidationMessage(rowData.controls.calculationUnit , submitted) ? ['ng-invalid', 'ng-dirty'] : []"  ></p-dropdown>
                  </td>

                  <td>
                    <p-inputNumber  formControlName="intervalUnitStart"  [minFractionDigits]="2"
                    [class]="showValidationMessage(rowData.controls.intervalUnitStart , submitted) ? ['ng-invalid', 'ng-dirty'] : []"  ></p-inputNumber>
                  </td>

                  <td>
                    <p-inputNumber  formControlName="intervalUnitEnd"  [minFractionDigits]="2"
                    [class]="showValidationMessage(rowData.controls.intervalUnitEnd , submitted) ? ['ng-invalid', 'ng-dirty'] : []"  ></p-inputNumber>
                  </td>

                  <td>
                    <p-inputNumber  formControlName="minimalCharge"  [minFractionDigits]="2"
                    [class]="showValidationMessage(rowData.controls.minimalCharge , submitted) ? ['ng-invalid', 'ng-dirty'] : []"  ></p-inputNumber>
                  </td>

                  <td>
                    <input pInputText type="text"  formControlName="remark"    />
                  </td>

                  <td>
                    <p-dropdown formControlName="isTieredGroup" [options]="yesNoOption"    placeholder="{{ 'Common.Message.ChooseOption' | translate }}"   appendTo="body"
                    [class]="showValidationMessage(rowData.controls.isTieredGroup , submitted) ? ['ng-invalid', 'ng-dirty'] : []"  ></p-dropdown>
                  </td>

                </tr>
              </ng-template>

            </p-table>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
  </p-card>
</div>
